import * as React from 'react';

import * as styles from './styles.css';

export interface ICommunicationImageProps {
  testId?: string;
}

export const CommunicationImage: React.FC<ICommunicationImageProps> = ({ testId = 'communication-image' }) => {
  return <div className={styles['container']} data-testid={testId} />;
};

CommunicationImage.displayName = 'CommunicationImage';
